export default __webpack_public_path__ + "static/media/lucas-benjamin.c823bb80.jpg";